export default {
    data() {
        return {
            infosUser: [],
            
            metas: {
                title: 'Administration - Games™ par ClickTestCPS',
                meta: [
                    { name: 'robots', content: 'none' }
                ]
            }
        }
    },
    mounted() {
        useHead(this.metas);
        this.checkSession();
    },
    methods: {
        checkSession() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1"
            }));

            axios
            .post(this.$store.state.apiUrl+"?request=checkSession", formData, { withCredentials: true })
            .then((response) => {
                if(response.data != 'admin') {
                    this.$router.replace({ name: 'adminConnection' });
                }
                else {
                    this.getSessionData();
                }
            });
        },
        getSessionData() {
            let formData = new FormData();
            formData.append('data', JSON.stringify({
                post: "1"
            }));
            
            axios
            .post(this.$store.state.apiUrl+"?request=getSessionData", formData, { withCredentials: true })
            .then((response) => {
                if(response.data.id) {
                    this.infosUser = response.data;
                }
            }).finally(() => { this.$store.commit('setRequestFalse') });
        }
    }
}